import { Button } from '@/components/ui/button'
import {
  createGoogleLoginPathForReturnTo,
  readPublicFormReturnToFromSearch,
} from '@/lib/auth-return-to'
import { Loader2 } from 'lucide-react'
import { motion } from 'motion/react'
import { useState } from 'react'

export default function LoginRoute() {
  const [isLoading, setIsLoading] = useState(false)
  const returnTo = readPublicFormReturnToFromSearch(window.location.search)
  const googleLoginPath = createGoogleLoginPathForReturnTo(returnTo)
  const businessDevelopmentImageUrl =
    'https://images.unsplash.com/photo-1556761175-b413da4baf72?auto=format&fit=crop&w=1800&q=82'

  return (
    <main className="grid min-h-screen bg-slate-950 lg:grid-cols-[1.1fr_0.9fr]">
      <section
        className="relative hidden overflow-hidden bg-slate-950 p-12 text-white lg:block"
        style={{
          backgroundImage: `linear-gradient(90deg, rgba(74, 47, 33, 0.9), rgba(74, 47, 33, 0.58)), url(${businessDevelopmentImageUrl})`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
        }}
      >
        <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-slate-950/80 to-transparent" />
        <div className="relative z-10 flex h-full flex-col justify-between">
          <div className="flex items-center gap-3">
            <div className="grid size-10 place-items-center rounded-lg bg-white text-lg font-black text-[#4a2f21]">
              客
            </div>
            <span className="text-lg font-semibold">客戶建檔問卷系統</span>
          </div>
          <div className="max-w-xl">
            <h1 className="text-5xl font-semibold leading-tight tracking-normal">
              業務填單、主管審核、客戶建檔一次完成。
            </h1>
            <p className="mt-5 max-w-lg text-base leading-7 text-white/80">
              讓新市場開發資料、客戶資訊與審核進度集中管理，登入後就能接續填寫或處理申請。
            </p>
          </div>
        </div>
        <div className="absolute bottom-6 left-8 text-xs font-medium text-white/65">MiaoForm</div>
      </section>
      <section className="flex items-center justify-center bg-white p-6">
        <motion.div
          initial={{ y: 40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.4 }}
          className="w-full max-w-md rounded-lg border border-slate-200 bg-white p-8 shadow-sm"
        >
          <div className="mb-8">
            <div className="mb-4 grid size-12 place-items-center rounded-lg bg-[var(--primary)] text-xl font-black text-white">
              客
            </div>
            <h2 className="text-2xl font-semibold">登入客戶建檔問卷系統</h2>
            <p className="mt-2 text-sm leading-6 text-slate-500">
              使用 Google 帳號登入後，可依權限填寫問卷、審核申請與管理客戶資料。
            </p>
          </div>
          <Button asChild variant="outline" size="lg" className="w-full justify-center">
            <a
              href={googleLoginPath}
              aria-disabled={isLoading}
              onClick={(event) => {
                if (isLoading) {
                  event.preventDefault()
                  return
                }
                setIsLoading(true)
              }}
            >
              {isLoading ? (
                <Loader2 className="size-4 animate-spin" />
              ) : (
                <span className="font-bold">G</span>
              )}
              使用 Google 登入
            </a>
          </Button>
          <p className="mt-6 text-center text-xs leading-5 text-slate-500">
            繼續即代表您同意服務條款與隱私權政策。
          </p>
        </motion.div>
      </section>
    </main>
  )
}
